module.exports = __webpack_public_path__ + "0895119b465fbd33825813a110118df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/headerLogo.png
// module id = 108
// module chunks = 0